// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Signup from "./features/auth/Signup";
import Login from "./features/auth/Login";
import Dashboard from "./features/dashboard/Dashboard";
import FeedbackForm from "./features/feedback/FeedbackForm";
import PrivateRoute from "./features/auth/PrivateRoute";
import Home from "./features/home/Home";
import SelectFormType from "./features/forms/SelectFormType";

function App() {
  return (
    <Router>
      {/* Optional: Add a global navigation bar here */}
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Login showLanding={true} />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login showLanding={false} />} />
        <Route path="/feedback/:uuid" element={<FeedbackForm />} />
        <Route path="/select-form" element={<SelectFormType />} />

        {/* Protected dashboard route */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        {/* Default route: redirect to /login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
